/* eslint-disable react-hooks/rules-of-hooks */
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Close } from '@emotion-icons/material/Close'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { Colors, Shapes, Typographies, useTypography } from 'src/components/theme'

const Wrapper = styled.div`
  display: flex;
  flex: none;
  height: 40px;
  background-color: ${Colors.bgDarkBlue};
  align-items: center;
  justify-content: space-between;
  padding-inline: ${Shapes.spacing[4]}px;
`

const Button = styled(ButtonWithIcon)`
  padding: ${Shapes.spacing[1]}px ${Shapes.spacing[2]}px;
  color: ${Colors.textWhite};
  border-color: ${Colors.textWhite};
  background-color: transparent;
  ${useTypography(Typographies.textmd)}
  svg {
    fill: ${Colors.textWhite};
  }
  &:hover {
    background-color: transparent;
    box-shadow: ${Colors.BOX_SHADOW};
  }
`

type InsightDownloadTopBarProps = {
  onClose: () => void
}
export const InsightDownloadTopBar = (props: InsightDownloadTopBarProps) => {
  const { onClose } = props

  return (
    <Wrapper>
      <Button
        onClick={onClose}
        style={{
          visibility: 'hidden',
        }}>
        <Close size={16} />
        Cancel
      </Button>
      <Typography variant="title2l" color={Colors.textWhite}>
        Report Preview
      </Typography>
      <Button color={Colors.textWhite} onClick={onClose}>
        <Close size={16} />
        Cancel
      </Button>
    </Wrapper>
  )
}
